import { Table } from "semantic-ui-react";

import React from "react";

import Form from "../../../../forms/components/Form/Form";
import TimeInput from "../../../../ui/components/DateInput/TimeInput";

export default function CalendarAvailabilityTableRow({ day, number }) {
	return (
		<Table.Row>
			<Table.Cell>{day}</Table.Cell>

			<Table.Cell>
				<Form.Field name={`calendarAvailability.${number}.start`}>
					<TimeInput formatAs="HH:mm" />
				</Form.Field>
			</Table.Cell>

			<Table.Cell>
				<Form.Field name={`calendarAvailability.${number}.end`}>
					<TimeInput formatAs="HH:mm" />
				</Form.Field>
			</Table.Cell>
		</Table.Row>
	);
}
